// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__ZdGKR","dragIcon":"Choice_dragIcon__25rFK","left":"Choice_left__1z0gE","input":"Choice_input__2WU8w"};